import { IAppContext } from "App/AppContext";
import { AuthSchemaLineOperation } from "models/auth/authSchemaLine";
import ProcessingActivity, { ProcessingActivityState } from "models/processingActivity";
import { FeatureTypes, hasUserDataPermission, hasUserFeature } from "services/Auth/featurePermissions";

export const canUpdateProcessingActivities = (processingActivities: ProcessingActivity[], appContext: IAppContext): boolean => {
  //returns true when the user can update all processing activities
  return processingActivities.every((processingActivity) => hasProcessingActivityUpdatePermission(appContext, processingActivity));
};

export const canDeleteProcessingActivities = (processingActivities: ProcessingActivity[], appContext: IAppContext): boolean => {
  //returns true when the user can delete all processing activities
  return processingActivities.every((processingActivity) => hasProcessingActivityDeletePermission(appContext, processingActivity));
};

export const hasProcessingActivityUpdatePermission = (appContext: IAppContext, processingActivity?: ProcessingActivity): boolean => {
  //returns true when the user has update permission according to the schema or when the user is owner and the processing activity is a concept
	if (!processingActivity) return false;

  const isOwner: boolean = processingActivity.ownerId === appContext.user.id || 
    appContext.globalDataCache.roles.get(processingActivity.ownerRoleId || '')?.users.some(user => user.id === appContext.user.id);
  
  return (
    hasUserDataPermission(appContext, [processingActivity.authSchemaId], AuthSchemaLineOperation.Update) || 
    ( 
      isOwner && 
      processingActivity.state === ProcessingActivityState.Concept &&
      hasUserFeature(appContext, FeatureTypes.ProcessingActivityApprovals)
    )
  );
};

export const hasProcessingActivityDeletePermission = (appContext: IAppContext, processingActivity?: ProcessingActivity): boolean => {
  //returns true when the user has delete permission according to the schema or when the user is owner and the processing activity is a concept
	if (!processingActivity) return false;

  const isOwner: boolean = processingActivity.ownerId === appContext.user.id || 
    appContext.globalDataCache.roles.get(processingActivity.ownerRoleId || '')?.users.some(user => user.id === appContext.user.id);
	
  return (
    hasUserDataPermission(appContext, [processingActivity.authSchemaId], AuthSchemaLineOperation.Delete) || 
    (
      isOwner && 
      processingActivity.state === ProcessingActivityState.Concept &&
      hasUserFeature(appContext, FeatureTypes.ProcessingActivityApprovals)
    )
  );
};